import { defineMessages } from "react-intl";

export default defineMessages({
  home: {
    id: "components.Breadcrumbs.home",
    defaultMessage: "Home"
  }
});
